import React from 'react';
import MultipleRemoveMerchants from "@/Pages/Merchants/Assets/MultipleAddedMerchantsAction/MultipleRemoveMerchants";
import MultiplePublishMerchants from "@/Pages/Merchants/Assets/MultipleAddedMerchantsAction/MultiplePublishMerchants";

const MultipleAddedMerchantsAction = ({checked}) => {
  return (
    <div className='flex'>
      <MultipleRemoveMerchants checked={checked}/>
      <MultiplePublishMerchants checked={checked}/>
    </div>
  );
};

export default MultipleAddedMerchantsAction;
